<template>
  <span>
    <slot name="button" v-bind="{onclick: toggle}">
      <b-button variant="primary" class="mr-1" size="xs" @click="toggle"><i class="fas fa-edit"></i>&nbsp;Edit</b-button>
    </slot>

    <b-modal
        @show="resetModal"
        @hidden="resetModal"
        ref="modal-container"
        v-model="modalShow"
        size="lg"
        :title="title"
        :static="true"
        :lazy="true"
        hide-footer
    >
      <form ref="form" @submit.stop.prevent="handleSubmit">
        <b-form-group v-if="!this.create" label="_ID" label-for="id-input">
          <b-form-input id="id-input"
                        v-model="formValues.id"
                        disabled
          />
        </b-form-group>

        <b-form-group label="Key" label-for="key-input">
          <b-form-input id="key-input"
                        v-model="formValues.key"
                        v-validate="{ required: true, min: 3 }"
                        :state="validateState('key-input')"
                        aria-describedby="key-input-live-feedback"
                        data-vv-name="key-input"
                        data-vv-as="Key"
                        autocomplete="off"
          />
          <b-form-invalid-feedback id="key-input-live-feedback">
            {{ veeErrors.first('key-input') }}
          </b-form-invalid-feedback>
        </b-form-group>

        <b-form-group label="Value" label-for="options-input">
          <v-jsoneditor
              ref="value-editor"
              v-model="formValues.value"
              :options="{ mode: 'code', enableSort: false, enableTransform: false }"
              :plus="false"
          />
          <b-form-input id="value-editor-error"
                        v-model="valueEditorError"
                        v-validate="{ is: '' }"
                        :state="validateState('value-editor-error')"
                        aria-describedby="value-editor-error-live-feedback"
                        data-vv-name="value-editor-error"
                        data-vv-as="Value"
                        hidden
                        autocomplete="off"
          />
          <b-form-invalid-feedback id="value-editor-error-live-feedback" v-if="veeErrors.first('value-editor-error')">
            {{ valueEditorError }}
          </b-form-invalid-feedback>

        </b-form-group>
      </form>

      <b-button class="mt-2 float-right" variant="primary" @click="handleSubmit">Save</b-button>
    </b-modal>
  </span>
</template>

<script>
import {getRouteIcon, ROUTE_AGGR_CONFIGS} from "../../utils/routerIcons";
import Multiselect from 'vue-multiselect';
import VJsoneditor from "v-jsoneditor/src/index";
import Vue from "vue";

export default {
  data() {
    return {
      modalShow: false,
      formValues: this.getInitialValues(),
      valueEditorError: '',
    }
  },
  components: {
    Multiselect,
    VJsoneditor,
  },
  props: {
    create: Boolean,
    title: String,
    defaultValues: Object
  },
  methods: {
    getInitialValues() {
      return {
        id: null,
        key: null,
        value: null,
      };
    },
    setDefaults() {
      let initialValues = this.getInitialValues();

      for (let field in initialValues) {
        Vue.set(this.formValues, field, initialValues[field]);
      }

      if (this.defaultValues) {
        for (let field in this.defaultValues) {
          Vue.set(this.formValues, field, this.defaultValues[field]);
        }
      }
    },
    validateState(ref) {
      if (
          this.veeFields[ref] &&
          (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.veeErrors.has(ref);
      }
      return null;
    },
    resetModal() {
      this.setDefaults();
    },
    hideModal() {
      this.$refs['modal-container'].hide();
    },
    toggle() {
      this.modalShow = !this.modalShow;
    },
    handleSubmit() {
      try {
        this.$refs['value-editor'].editor.get();
        this.valueEditorError = '';
      } catch {
        this.valueEditorError = 'The Value must be a valid json string';
      }

      this.$validator.validateAll().then(result => {
        if (!result) {
          return;
        }

        this
            .$http({
              url: this.create ? '/api/v1/aggr-config' : '/api/v1/aggr-config/' + this.formValues.id,
              data: {
                ...this.formValues,
              },
              method: this.create ? 'POST' : 'PUT',
              headers: {
                'Content-Type': 'application/json',
              },
            })
            .then(() => {
              setTimeout(() => {
                this.$emit('finish')
              }, 500);

              this.hideModal();
              this.$toastr.i('Success');
            })
            .catch((err) => {
              this.$toastr.e(JSON.stringify(err.response.data.message));

              throw err;
            });
      });
    },
  },
  computed: {
    routeIcon: () => getRouteIcon(ROUTE_AGGR_CONFIGS),
  },
  mounted() {
    this.setDefaults();
  },
}
</script>
